import { useEffect, useEffectEvent, useMemo } from 'react';

export const useStartFromEventKey = <T>(
  eventKey: string | null,
  value: T,
  onValueChange: (value: string | T) => void,
) => {
  const startValue = useMemo(() => {
    if (eventKey === 'Backspace') {
      return '';
    }

    if (eventKey?.length === 1) {
      return eventKey;
    }

    return value;
  }, [value, eventKey]);

  const onMount = useEffectEvent(() => {
    onValueChange(startValue);
  });

  useEffect(() => {
    onMount();
  }, []);

  return startValue;
};
